export default __webpack_public_path__ + "static/Emailgate_hovered-90b323d51ab15e129e9e78fdf8e14ea2.png";